export default "__VITE_ASSET__Cd0omqZ3__"